module.exports = __webpack_public_path__ + "Roboto-Light.3b813c2ae0d04909a33a.woff";


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/font/roboto/Roboto-Light.woff
// module id = ../../../../../src/libs/mdbootstrap/font/roboto/Roboto-Light.woff
// module chunks = styles